(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurina-social-proof"] && !Shopify.designMode) return;
  try {
    
  class AurinaProof extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-proof-track]');
      this.dialog = this.querySelector('[data-proof-dialog]');
      this.dialogImage = this.querySelector('[data-proof-dialog-image]');
      this.previewImages = this.querySelectorAll('[data-proof-preview]');
      this.previewObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const image = entry.target;
            image.src = image.dataset.proofPreview;
            image.removeAttribute('data-proof-preview');
            this.previewObserver.unobserve(image);
          });
        },
        { rootMargin: '800px 320px' }
      );
      this.previewImages.forEach((image) => this.previewObserver.observe(image));
      this.querySelector('[data-proof-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-proof-next]')?.addEventListener('click', () => this.move(1));
      this.querySelectorAll('[data-proof-open]').forEach((button) => {
        button.addEventListener('click', () => this.open(button));
      });
      this.querySelector('[data-proof-close]')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }

    disconnectedCallback() {
      this.previewObserver?.disconnect();
    }

    move(step) {
      if (!this.track) return;
      const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
      this.track.scrollBy({ left: step * direction * this.track.clientWidth * 0.82, behavior: 'smooth' });
    }

    open(button) {
      if (!this.dialog || !this.dialogImage) return;
      this.dialog.dataset.kind = button.dataset.proofKind;
      this.dialogImage.src = button.dataset.proofSrc;
      this.dialogImage.alt = button.dataset.proofAlt;
      this.dialog.showModal();
    }
  }

  if (!customElements.get('aurina-proof')) customElements.define('aurina-proof', AurinaProof);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
